
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { ISchemaDataDTO } from 'dto/ISchemaDataDTO';

@Component({
  name: 'NodeDialogForm',
})
export default class NodeDialogForm extends Vue {
  @Prop({ required: true, type: Object })
  data: {
    title: string;
    action: any;
  };

  @Prop({ required: true, type: String })
  title: string;

  @Prop({
    type: Object,
    required: false,
  })
  type: ISchemaDataDTO;
}
